module.exports = __webpack_public_path__ + "img/icon_06.49077503.png";